import React, { useEffect, useState } from 'react'
import { ResponsivePie } from '@nivo/pie'
import {data} from './data'


function getWindowSize() {
    const {innerWidth} = window;
    return [innerWidth];
  }
const PieChart = ({ datas /* see data tab */ ,tough,tougher,medium,easy}) => {
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const data = [
      {
        id: "Easy",
        label: "Easy",
        value: easy,
        color: "#BABD0C",
      },
      {
        id: "Medium",
        label: "Medium",
        value: medium,
        color: "#3339CA",
      },
      {
        id: "Tough",
        label: "Tough",
        value: tough,
        color: "#F5822E",
      },
      {
        id: "Tougher",
        label: "Tougher",
        value: tougher,
        color: "#22CCB8",
      },
    ];
    useEffect(() => {
      function handleWindowResize() {
        setWindowSize(getWindowSize());
      }
      window.addEventListener('resize', handleWindowResize);
      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, []);
    return (
        <>
        {/*windowSize*/}
    <ResponsivePie
        data={data}
        margin={windowSize > 575 ? { top: 40, right: 90, bottom: 80, left: 30 } : { top: 40, right: 40, bottom: 80, left: 40 }}
        innerRadius={0.75}
        padAngle={1}
        cornerRadius={4}
        activeOuterRadiusOffset={8}
        colors={{ scheme: 'nivo' }}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    '0'
                ]
            ]
        }}
        arcLinkLabelsTextOffset={8}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color', modifiers: [] }}
        arcLabelsTextColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    2
                ]
            ]
        }}
        legends={[
            {
                anchor: windowSize > 575 ? "right" : "bottom",
                direction: windowSize > 575 ?'column' : "row",
                justify: false,
                translateX: 0,
                translateY:windowSize > 575 ? 0 : 40,
                itemsSpacing: 8,
                itemWidth: 70,
                itemHeight: 18,
                itemTextColor: '#999',
                itemDirection: 'left-to-right',
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: 'square',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ]
            }
        ]}
    />
    </>
)}
export default PieChart